import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// initial state
export const INITIAL_STATE = {
  submitting: false,
  success: false,
  error: false,
}

// action types
export const SUBMIT = 'newsletter/SUBMIT'
export const SUBMITTED = 'newsletter/SUBMITTED'
export const ERROR = 'newsletter/ERROR'
export const CLEAN = 'newsletter/CLEAN'

// submit :: (String, String, Boolean, Boolean, String) -> Action
export const submit = (
  email,
  country,
  newsletterSubscription,
  partnerSubscription,
  captcha,
) => ({
  type: SUBMIT,
  email,
  country,
  newsletterSubscription,
  partnerSubscription,
  captcha,
})

// submitted :: () -> Action
export const submitted = always({ type: SUBMITTED })

// error :: () -> Action
export const error = always({ type: ERROR })

// clean :: () -> Action
export const clean = always({ type: CLEAN })

// newsletter :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [SUBMIT]: state => ({
    ...state,
    submitting: true,
    success: false,
    error: false,
  }),

  [SUBMITTED]: state => ({
    ...state,
    submitting: false,
    success: true,
    error: false,
  }),

  [ERROR]: state => ({
    ...state,
    submitting: false,
    success: false,
    error: true,
  }),

  [CLEAN]: () => INITIAL_STATE,
})
